module.exports = __webpack_public_path__ + "static/img/1810_4.9d617cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_4.jpg
// module id = Fw6U
// module chunks = 1